export default __webpack_public_path__ + "static/media/edit-icon.0257a651.svg";